import { useCallback, useMemo, useState } from 'react';
import { LoadingModal, Modal } from '@adc/parallax-component-library';
import { MainContainer, Providers } from 'Components/utility';
import { ApiStatus, APP_RETURN_TIMEOUT } from 'Constants';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';

type Props = {
  errorStatus?: number;
};

const InitializationErrorPage = ({ errorStatus }: Props) => {
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const error = useMemo(() => {
    switch (errorStatus) {
      case ApiStatus.INTERNAL_SERVER_ERROR:
        return {
          title: 'Global.modals.internetConnectionError.title',
          message: 'Global.modals.internetConnectionError.body',
        } as const;
      case ApiStatus.UNAUTHORIZED:
        return {
          title: 'Global.modals.featureNotAvailable.title',
          message: 'Global.modals.featureNotAvailable.body',
        } as const;
      default:
        return {
          title: 'Global.modals.internetConnectionError.title',
          message: 'Global.modals.errorCommunicatingServer.body',
        } as const;
    }
  }, [errorStatus]);

  const onClose = useCallback(() => {
    setIsOpen(false);

    setLoading(true);

    notifyApp('adc-webview:navigate-back-app');

    // Give the app some time to redirect the user back.
    setTimeout(() => {
      setLoading(false);
    }, APP_RETURN_TIMEOUT);
  }, []);

  return (
    <Providers>
      <MainContainer>
        {loading && <LoadingModal aria-label="Loading" />}
        <Modal
          isOpen={isOpen}
          header={i18n.t(error.title)}
          details={i18n.t(error.message)}
          primaryAction={{
            label: i18n.t('Global.microcopy.common.okCap'),
            onPress: onClose,
          }}
        />
      </MainContainer>
    </Providers>
  );
};

export { InitializationErrorPage };
